import React from 'react';
import { Provider } from '../context';
import Tooltip from '../Tooltip';

const TooltipProvider = ({
  children
}) => {
  const ref = React.useRef(null);
  const value = React.useMemo(() => ({
    show: (title, position, direction, styleOptions) => {
      var _ref$current;

      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.display(title, position, direction, styleOptions);
    },
    hide: () => {
      var _ref$current2;

      (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.hide();
    }
  }), []);
  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, children, /*#__PURE__*/React.createElement(Tooltip, {
    ref: ref
  }));
};

export default TooltipProvider;